var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(["\n  display: inline;\n  position: relative;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  background-color: ", ";\n  background-clip: padding-box;\n  overflow: visible;\n  border-radius: 3px;\n"], ["\n  display: inline;\n  position: relative;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  background-color: ", ";\n  background-clip: padding-box;\n  overflow: visible;\n  border-radius: 3px;\n"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 2px 5px;\n  top: -9px;\n  left: 0;\n  margin: 0 !important;\n  font-size: 0.64285714rem;\n  position: absolute;\n  z-index: 100;\n  background-color: #767676 !important;\n  color: #fff !important;\n  display: inline-block;\n  line-height: 1;\n  vertical-align: baseline;\n  font-weight: 700;\n  border-radius: 0.28571429rem;\n  transition: background 0.1s ease;\n"], ["\n  padding: 2px 5px;\n  top: -9px;\n  left: 0;\n  margin: 0 !important;\n  font-size: 0.64285714rem;\n  position: absolute;\n  z-index: 100;\n  background-color: #767676 !important;\n  color: #fff !important;\n  display: inline-block;\n  line-height: 1;\n  vertical-align: baseline;\n  font-weight: 700;\n  border-radius: 0.28571429rem;\n  transition: background 0.1s ease;\n"]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

/** @jsx jsx */
import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { cx } from "emotion";
import { jsx, css } from "@emotion/core";
import { ThemeProvider, CSSReset, theme, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton } from "@chakra-ui/core";
import { palette } from "../styles";
import FieldValueDisplay from "./FieldValueDisplay";
import FieldForm from "./FieldForm";

var rootXPadding = 4;
export var rootStyles = css(_templateObject, rootXPadding, rootXPadding, palette.grayLight);

var nameLabelStyles = css(_templateObject2);

function FieldNameLabel(props) {
  return jsx("div", _extends({ css: nameLabelStyles }, props));
}

function Field(_ref) {
  var node = _ref.node,
      className = _ref.className,
      style = _ref.style,
      container = _ref.container,
      _ref$showFormulaNameT = _ref.showFormulaNameTooltip,
      showFormulaNameTooltip = _ref$showFormulaNameT === undefined ? true : _ref$showFormulaNameT,
      onSnapshot = _ref.onSnapshot,
      _ref$onEditingChange = _ref.onEditingChange,
      onEditingChange = _ref$onEditingChange === undefined ? function () {} : _ref$onEditingChange;

  var _useState = useState(false),
      hovered = _useState[0],
      setHovered = _useState[1];

  var name = node.name,
      isEditing = node.isEditing,
      isSliderField = node.isSliderField,
      store = node.store;

  var nameLabelVisible = showFormulaNameTooltip && !isEditing && (hovered || store.isSomeNodeEditing);

  useEffect(function () {
    if (!onSnapshot) {
      return;
    }

    var dispose = node.onSnapshot(onSnapshot);

    return function () {
      return dispose();
    };
  }, [onSnapshot]);

  useEffect(function () {
    onEditingChange(isEditing);
    if (!isEditing) {
      setHovered(false);
    }
  }, [isEditing]);

  return jsx(
    ThemeProvider,
    { theme: theme },
    jsx(CSSReset, null),
    jsx(
      "span",
      {
        css: rootStyles,
        className: cx("rxp-field", "rxp-formula", className) // ToDo: remove rxp-formula
        , style: style,
        onMouseEnter: function onMouseEnter() {
          return !isEditing && setHovered(true);
        },
        onMouseLeave: function onMouseLeave() {
          return setHovered(false);
        },
        tabIndex: 0,
        onFocus: function onFocus() {
          if (!isEditing && !isSliderField) {
            node.toggleEditing(true);
          }
        }
      },
      nameLabelVisible && jsx(
        FieldNameLabel,
        null,
        name
      ),
      jsx(
        Popover,
        {
          returnFocusOnClose: false,
          isOpen: isEditing,
          onClose: function onClose() {
            return node.toggleEditing(false);
          },
          closeOnBlur: false,
          usePortal: true
        },
        jsx(
          PopoverTrigger,
          null,
          jsx(FieldValueDisplay, { node: node })
        ),
        jsx(
          PopoverContent,
          {
            zIndex: 99999,
            p: 3,
            container: container,
            width: "250px"
          },
          jsx(PopoverArrow, null),
          jsx(PopoverCloseButton, null),
          jsx(FieldForm, { node: node })
        )
      )
    )
  );
}

export default observer(Field);